import { AvatarWithStatus } from '@/components/common/avatar-with-status';
import type { ForwardListItem } from '@/hooks/contacts/use-forward-list';

type Props = {
  session: ForwardListItem;
  isSelected: boolean;
  onSelectSession: (forwardSession: ForwardListItem, selected: boolean) => void;
};

export default function ForwardSessionListItem({ session, isSelected, onSelectSession }: Props) {
  return (
    <button
      type='button'
      className='flex w-full py-2 px-5 items-stretch gap-4 rounded-2xl transition-colors min-h-12'
      onClick={() => onSelectSession(session, !isSelected)}>
      {session.imageURL && (
        <div className='flex flex-col justify-center'>
          <AvatarWithStatus
            isOnline={false}
            className='size-12'
            size={[48, 48]}
            imageUrl={session.imageURL}
            label={session.name}
          />
        </div>
      )}

      <div className='flex min-w-0 flex-auto flex-col items-stretch justify-center gap-1 overflow-hidden'>
        <h5 className='line-clamp-1 break-all text-h2 desktop:text-sm text-start'>{session.name}</h5>
      </div>

      <div className='flex flex-1 items-center justify-end'>
        <input
          type='checkbox'
          name={`select-${session.key}`}
          className='checkbox rounded-full checked:checkbox-primary'
          readOnly
          checked={isSelected}
        />
      </div>
    </button>
  );
}
